import { useState } from 'react';
import './../style/ButtonToTop.css';
import './../style/Global.css';

const ButtonToTop = () => {
  const [isVisible, setVisible] = useState(false);

  const toggleVisible = () => { 
    const scrolled = document.documentElement.scrollTop; 
    return scrolled > 300 ? setVisible(true) : setVisible(false);
  }; 
  
  const scrollToTop = () =>{ 
    window.scrollTo({ 
      top: 0,  
      behavior: 'smooth'
    }); 
  }; 
  
  window.addEventListener('scroll', toggleVisible);
  
  return (
    isVisible && 
    <button
      onClick={scrollToTop}
      className='button-to-top'
    >
      <a href=" ">    
        <span className='button-to-top-icon'>&#10095;</span> 
      </a>  
    </button>
  )
}

export default ButtonToTop 